import React from 'react';
import _ from 'lodash';
import cls from 'classnames';
import {
    faTruck,
    faSave,
    faTrashAlt,
    faPlus,
    faEdit,
    faEye,
    faTimes,
    faInfoCircle,
    faTriangleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isEqual } from 'lodash-es';
import {
    Button,
    Col,
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Alert,
    Input,
} from 'reactstrap';
import { v4 as uuid } from 'uuid';
import { Prompt, withRouter } from 'react-router-dom';
import moment from 'moment';
import {
    AppPageForm,
    FlexCenterRow,
    FlexColumnStart,
    FlexStartRow,
    FormCircularProgress,
    FormDivider,
    FormGroupColumn,
    FormCheckbox,
    GroupedRow,
    onFieldChange,
    onReactSelectChanged,
    SmallOutlineButton,
    SubHeading,
    toasty,
    FormLabel,
} from '../common/forms/FormElements';
import { BaseFormViewModel } from '../common/ViewModel';
import FileUpload from '../common/forms/FileUpload';
import ConstrainedTimeInput from '../common/forms/ConstrainedTimeInput';
import CommonContext, { SupportedFileExtensions, Weekdays } from '../Common';
import { MomentDateFormat } from '../MomentDateFormat';
import { ApiRoutes } from '../ApiRoutes';
import { AppNavPaths } from '../AppNavPaths';
import { Job } from './Job';
import { util } from '../Util';
import ValidatedSelect from '../common/forms/ValidatedSelect';
import AddressFormNew from '../address/AddressFormNew';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { Address } from '../address/Address';
import JobFileAttachments from './JobFileAttachments';
import { JobOverride } from './JobOverride';
import JobOverrideModal from './JobOverrideModal';
import CrewDisplay from './CrewDisplay';
import PhaseTotalWarning from './PhaseTotalWarning';
import './JobForm.scss';
import LongTermScheduleResourceTable from './LongTermScheduleResourceTable';

class JobForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
        this.uploadsRef = React.createRef();
        this.addressFormRef = React.createRef();

        const stateBase = {
            job: new Job(),
            dispatchLocations: [],
            weeks: [],
            usCounties: [],
            addressEditType: null, // from object const
            selectedAddressType: '',
            addressFormTitle: '',
            showTimesheetOverview: false,
            longTermSchedulers: [],
            fieldUsers: [],
            tableRequired: {},
            meetingLocationRequired: {},
            jobLocationRequired: {},
            pageModified: false,

            customerSubcontractors: [],
            showAddSetupCharge: false,
            showAddPermitFees: false,

            // Job override options
            showJobOverrideModal: false,
            currentJobOverride: null,
            isForLongTermSchedule: false,
            longTermSchedule: null,
            dateOverviews: [],
            crew: null,
            jobBeforeSave: null,
            employees: [],
            equipments: [],
            equipmentTypes: [],
            equipmentGroups: [],
            applicationGroups: [],
            phasesValid: true,
            equimentTypeCountsValid: true,
            jobResourcesValid: true,
            equipmentTypeCounts: [],
            equipmentTypeIdsRequiringMoves: [],
            lowboyResources: [],

            edit: {
                dayStatuses: {},
                initialResources: null,
                allowRequestedBy: true,
                allowWeekOfDate: true,
                allowForemen: true,
                allowDispatchOfficeLocation: true,
                allowStartTime: true,
                allowWorkOrderNumber: true,
                // Needs special checks - what you can do is more nuanced.
                allowResources: true,
                allowMeetingLocation: true,
                allowJobLocation: true,
                // Currently will always be allowed.
                allowNotes: true,
                allowDelete: false,
                allowSubcontractor: true,
                // Local tracking of resource errors.
                resourceErrors: {},
            },

            resourceTableError: '',
            showDeleteModal: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onChange = this.onChange.bind(this);
        this.onSelectChanged = this.onSelectChanged.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChangeResourceDay = this.onChangeResourceDay.bind(this);
        this.onChangeNonResourceDay = this.onChangeNonResourceDay.bind(this);
        this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
    }

    // #region METHODS
    componentDidMount() {
        return this.populateState();
    }

    setPageModified = (b) => this.setState({ pageModified: b });

    // #region CONTACTS

    onAddLocation = (type) => {
        const { job } = this.state;
        const selectedAddress = new Address();
        const addressFormTitle = `New ${
            type === 'meetingLocation' ? 'Meeting' : 'Job'
        } Location`;
        this.setState({
            selectedAddressType: type,
            addressFormTitle,
        });

        // dont show duplicate location if ones filled out already
        let show = true;
        if (job.meetingLocation || job.jobLocation) show = false;

        this.addressFormRef.current.open(
            selectedAddress,
            addressFormTitle,
            show,
            `Same as ${
                type === 'meetingLocation' ? 'Job Location' : 'Meeting Location'
            }`
        );
    };

    onAddPermitFees = () => {
        this.setState({ showAddPermitFees: false });
    };

    onAddPermitFeesClick = () => {
        this.setState({ showAddPermitFees: true });
    };

    onAddSetupCharge = () => {
        this.setState({ showAddSetupCharge: false });
    };

    onAddSetupChargeClick = () => {
        this.setState({ showAddSetupCharge: true });
    };

    onChange = onFieldChange;

    onChangeNonResourceDay = (nonResource, e) => {
        // prolly do something here
        const { job } = this.state;
        const updated = job.nonResources.map((r) => {
            if (r.id === nonResource.id) {
                return { ...r, [e.target.name]: e.target.checked };
            }
            return { ...r };
        });

        job.nonResources = updated;

        this.setState({ job, pageModified: true });
    };

    onLongTermSchedulerChanged = (e) => {
        const { job } = this.state;

        if (e) {
            job.requestedById = e.id;
        } else {
            job.requestedById = null;
        }

        this.setState({ job });
    };

    onForemenChanged = (e) => {
        const { job } = this.state;

        if (e) {
            job.foremenId = e.id;
        } else {
            job.foremenId = null;
        }

        this.setState({ job });
    };

    onChangeResourceDay = (resource, e) => {
        const { job, edit } = { ...this.state };

        let val = parseInt(e.target.value);

        if (isNaN(val)) {
            val = 0;
        }

        if (val >= 100) {
            toasty.error('Resource assignment cannot exceed 100.');
            return;
        }

        const dayName = e.target.name;
        const { resourceName } = resource;

        // Note: e.target.name === "monday"
        //      resource.resourceName === "Work Truck"
        const msg = this.getResourceEditValidationMessage(
            dayName,
            resourceName,
            val
        );

        // if we're changing "Flaggers (Planning)"", associate any errors with "Flaggers"
        const nonPlanningResourceName =
            this.getNonPlanningResourceName(resourceName);

        // Probably a better way of doing this.
        const msgKey = `${nonPlanningResourceName}_${dayName}`;

        if (msg) {
            toasty.error('Resource Update', msg);

            // Flag an error on the resource for the day.
            edit.resourceErrors[msgKey] = msg;
        } else {
            // Noop if it doesn't exist.
            delete edit.resourceErrors[msgKey];
        }

        job.resources = job.resources.map((r) => {
            if (r.id === resource.id) {
                const res = { ...r, [dayName]: `${val}` };
                return res;
            }
            return { ...r };
        });

        job.resources = job.resources.map((r) => {
            if (
                r.isPlanningOnly &&
                !this.doesAfadAssignmentExistForDay(job, dayName)
            ) {
                const planningResource = { ...r, [dayName]: '0' };
                return planningResource;
            }

            return { ...r };
        });

        this.setState({ job, edit, pageModified: true });
        this.hydrateSetupCharges();
    };

    onManagedLowboyResourceChange = (lowboyResources) => {
        this.setState({ lowboyResources });
    };

    getWeekJobResource = (job, weekResourceData) => {
        const { weekOfDate } = weekResourceData;

        return job.weekJobResources.find((wjr) =>
            moment(wjr.weekOfDate).isSame(weekOfDate, 'day')
        );
    };

    getOrCreateJobOverride = (weekResourceData, weekJobResource) => {
        const { overrideDate } = weekResourceData;

        return (
            weekJobResource.jobOverrides.find((jo) =>
                moment(jo.overrideDate).isSame(overrideDate, 'day')
            ) || { overrideDate }
        );
    };

    updateJobOverride = (weekJobResource, jobOverride) => {
        weekJobResource.jobOverrides = weekJobResource.jobOverrides.filter(
            (jo) =>
                !moment(jo.overrideDate).isSame(jobOverride.overrideDate, 'day')
        );

        weekJobResource.jobOverrides.push(jobOverride);
    };

    async onDeleteConfirmed() {
        const { job } = this.state;
        job.isDeleted = true;

        this.setState({ job });

        await this.saveJob();

        this.setState({ showDeleteModal: false });
    }

    onEditLocation = (type) => {
        const { job } = { ...this.state };
        const selectedAddress = { ...job[type] };
        const addressFormTitle = `Edit ${
            type === 'meetingLocation' ? 'Meeting' : 'Job'
        } Location`;

        this.setState({
            selectedAddress,
            selectedAddressType: type,
            addressFormTitle,
            pageModified: true,
        });

        this.addressFormRef.current.open(selectedAddress, addressFormTitle);
    };

    // #endregion

    onPermitFeesApplyChange = () => {
        const { job } = this.state;

        job.permitFeesApply = !job.permitFeesApply;

        this.setState({ job });
    };

    onPreviewDrop = (files) => {
        this.setState({
            files: this.state.files.concat(files),
        });
    };

    onRemoveAttachment = async (file) => {
        const { job } = { ...this.state };
        const url = ApiRoutes.job.attachment(job.id);
        const resp = await util.fetch.delete(url, file, util.fetch.format.json);
        if (resp) {
            toasty.success('Attachment removed.');
            this.getAttachments();
        } else {
            toasty.error(
                'There was a either a problem removing the attachment or it has already been removed.  Please try your request again after refreshing the page.'
            );
        }
    };

    onSaveAddress = (address) => {
        let {
            job,
            selectedAddressType,
            meetingLocationRequired,
            jobLocationRequired,
        } = this.state;

        job[selectedAddressType] = { ...address };

        if (address.duplicate) {
            // if the other is blank fill it in.
            if (selectedAddressType === 'jobLocation' && !job.meetingLocation) {
                const mAddress = util.object.clone(address);
                mAddress.id = uuid();

                job.meetingLocation = mAddress;
            }

            if (selectedAddressType === 'meetingLocation' && !job.jobLocation) {
                const jAddress = util.object.clone(address);
                jAddress.id = uuid();

                job.jobLocation = jAddress;
            }
        }

        if (job.meetingLocation) meetingLocationRequired = {};

        if (job.jobLocation) jobLocationRequired = {};

        this.setState({
            job,
            meetingLocationRequired,
            jobLocationRequired,
        });
    };

    onSelectChanged = onReactSelectChanged;

    onSubmit = async (e) => {
        const { job, saving, longTermSchedule } = this.state;

        if (
            !this.validateSetupCharges() ||
            !this.validateArcGisLocationsForDays() ||
            !this.onValidate()
        ) {
            toasty.error(
                'Errors Found',
                'Please check the form for missing required data and invalid values.'
            );
            this.setState({ saving: false });
            return false;
        }

        if (saving) {
            return false;
        }

        this.setState({ saving: true, jobBeforeSave: _.cloneDeep(job) }, () => {
            if (job.meetingLocation) {
                // Revert uuid
                job.meetingLocation.id =
                    job.meetingLocation.id.constructor === String
                        ? null
                        : job.meetingLocation.id;
            }

            if (job.jobLocation) {
                job.jobLocation.id =
                    job.jobLocation.id.constructor === String
                        ? null
                        : job.jobLocation.id;
            }

            job.resources = job.resources.map((r) => {
                r.id = r.id.constructor === String ? null : r.id;

                if (!_.isEmpty(r.jobResourceOverrides)) {
                    r.jobResourceOverrides = r.jobResourceOverrides.map((o) => {
                        o.id =
                            !o.id || o.id.constructor === String ? null : o.id;
                        return o;
                    });
                }

                return r;
            });

            job.weekJobResources = job.weekJobResources.map((wjr) => {
                wjr.jobResources = wjr.jobResources.map((r) => {
                    r.id = !r.id || r.id.constructor === String ? null : r.id;

                    if (!_.isEmpty(r.jobResourceOverrides)) {
                        r.jobResourceOverrides = r.jobResourceOverrides.map(
                            (o) => {
                                o.id =
                                    !o.id || o.id.constructor === String
                                        ? null
                                        : o.id;
                                return o;
                            }
                        );
                    }

                    return r;
                });

                if (!_.isEmpty(wjr.jobOverrides)) {
                    wjr.jobOverrides = wjr.jobOverrides.map((jo) => {
                        jo.id =
                            !jo.id || jo.id.constructor === String
                                ? null
                                : jo.id;
                        return jo;
                    });
                }

                return wjr;
            });

            job.overrides = job.overrides?.map((o) => ({
                ...o,
                weekOfDate: job.weekOfDate,
                job: {
                    weekOfDate: job.weekOfDate,
                },
            }));

            this.setState({
                originalJob: util.object.clone(job),
                pageModified: false,
            });

            // Clear any fluent api errors
            this.clearErrors();

            // process saves - LTS will branch internally
            if (longTermSchedule) {
                this.saveLongTermScheduleJobs();
            } else if (job.id) {
                this.saveJob();
            } else {
                this.createJob();
            }
        });
    };

    onValidate = () => {
        let {
            job,
            tableRequired,
            meetingLocationRequired,
            jobLocationRequired,
            edit,
            resourceTableError,
            isForLongTermSchedule,
        } = this.state;

        let valid = true;

        tableRequired = {};
        meetingLocationRequired = {};
        jobLocationRequired = {};

        const requiredStyle = {
            border: '1px solid',
            borderRadius: '0.25rem',
            borderColor: '#ed1c24',
        };

        // The var sum below is unused?
        // Resources
        // at least 1 day on the entire grid needs to be 1 or more.  So sum entire grid and greater than 0
        resourceTableError = '';
        // let sum = 0;
        // (job.resources ?? []).forEach(x => {
        //    sum += parseInt(x.sunday) + parseInt(x.monday) + parseInt(x.tuesday) + parseInt(x.wednesday) + parseInt(x.thursday) + parseInt(x.friday) + parseInt(x.saturday);
        // });

        // Bypass this per CW
        // if (sum === 0) {
        //    valid = false;

        //    resourceTableError += "At least 1 resource is required for a job. ";

        //    tableRequired = requiredStyle;
        // }

        // Resources - added after "At least 1 resource" check.
        // Only applicable to job edits - not new jobs.
        const resourceErrorKeys = Object.keys(edit.resourceErrors);
        if (!isForLongTermSchedule && resourceErrorKeys.length > 0) {
            valid = false;

            resourceErrorKeys.forEach(
                (key) => (resourceTableError += `${edit.resourceErrors[key]} `)
            );

            tableRequired = requiredStyle;
        }

        // we only validate manual locations when ArcGIS locations aren't present
        if (!this.areAnyLocationsDefined()) {
            // Locations
            if (!job.meetingLocation) {
                valid = false;
                meetingLocationRequired = requiredStyle;
            }

            if (!job.jobLocation) {
                valid = false;
                jobLocationRequired = requiredStyle;
            }
        }

        // Validate Start Time
        if (!job.startTime) {
            valid = false;
        }

        if (this.getHasSelectedCrewWithoutLead()) {
            valid = false;
        }

        this.setState({
            formValidated: valid,
            saving: valid,
            tableRequired,
            meetingLocationRequired,
            jobLocationRequired,
            resourceTableError,
        });

        return valid;
    };

    getAttachments = async () => {
        const { job } = { ...this.state };
        const attachments = await util.fetch.get(
            ApiRoutes.job.getAllAttachments(job.id)
        );
        job.uploads = attachments ?? [];
        this.setState({ job });
    };
    // #endregion

    getCounty = (location) => {
        if (!location || !location.usCountyId) {
            return null;
        }

        const { usCounties } = this.state;

        const county = usCounties.find((c) => c.id == location.usCountyId);

        return county || null;
    };

    getExistingOverrideDay = (day) => {
        const { job } = { ...this.state };

        const overrideDay = Weekdays[day.getDay()].name;
        const existingOverride = (job.overrides ?? []).find(
            (override) =>
                override.overrideDay === overrideDay && !override.isDeleted
        );

        return existingOverride;
    };

    getNonPlanningResourceName(resourceName) {
        return resourceName.startsWith('Flagger')
            ? resourceName.split(' ')[0]
            : null;
    }

    /**
     * For cases where we have paired planning/resource versions of job resources
     * (as in the case of of "Flaggers" and "Flaggers (Planning)"), find the
     * paired version of the resource and extract its resource
     * count for the given day.
     * Planning resources are enabled by the EnableRequestedPersonnel tenant setting.
     * @param {*} resourceName
     * @param {*} day
     * @returns
     */
    getPairedResourceCount(resourceName, day) {
        const { job, tenantSettings } = this.state;

        if (!tenantSettings || !tenantSettings.enableRequestedPersonnel) {
            return null;
        }

        const nonPlanningResourceName =
            this.getNonPlanningResourceName(resourceName);

        if (nonPlanningResourceName == null) {
            return null;
        }

        const isNonPlanningResource = resourceName == nonPlanningResourceName;

        const alternateResource = job.resources.find(
            (r) =>
                r.resourceName !== resourceName &&
                r.resourceName.startsWith(nonPlanningResourceName)
        );

        if (
            !alternateResource ||
            // if we're editing Flaggers and Flaggers (Planning) is disabled because
            // an AFAD resource hasn't been assigned for the day, a zero value
            // on Flaggers (Planning) is not an issue
            (isNonPlanningResource &&
                !this.doesAfadAssignmentExistForDay(job, day))
        ) {
            return null;
        }

        return alternateResource[day];
    }

    getResourceEditValidationMessage(day, resourceName, val) {
        // You want a null message - means everything is OK.
        let msg = null;

        const resourceStatus = this.getResourceStatus(day, resourceName);

        if (resourceStatus && resourceStatus.statusCounts) {
            const maxStatus = resourceStatus.maxConfirmationStatusId;

            // If nothing has been assigned, you can edit whatever you'd like.
            if (maxStatus < 2) return null;

            // If the max status is "Scheduled", you cannot edit the value to go below assigned resources.
            // If the max status is 3 or 4, you can only add resources - number must be greater than the
            // counts of all statuses.
            const minCheckStatus = maxStatus === 2 ? 2 : 1;

            const threshold = Object.keys(resourceStatus.statusCounts).reduce(
                (acc, currentStatus) => {
                    // Set an upper limit of 4 in case we add future statuses.
                    if (currentStatus >= minCheckStatus && currentStatus <= 4)
                        acc += resourceStatus.statusCounts[currentStatus];

                    return acc;
                },
                0
            );

            if (val < threshold) {
                const du = `${day[0].toUpperCase()}${day.substring(1)}`;

                switch (maxStatus) {
                    case 2:
                        msg = `"${resourceName}" must be at least ${threshold} on ${du} because of existing assignments.`;
                        break;
                    case 3:
                    case 4:
                        msg = `"${resourceName}" must be at least ${threshold} on ${du} because notifications have already been sent.`;
                        break;
                    default:
                        break;
                }
            }
        }

        if (!msg) {
            const pairedResourceCount = this.getPairedResourceCount(
                resourceName,
                day
            );

            if (pairedResourceCount !== null) {
                const uppercaseDay = `${day[0].toUpperCase()}${day.substring(
                    1
                )}`;

                const isPlanning = resourceName.includes('Planning');

                if (isPlanning && Number(pairedResourceCount) > Number(val)) {
                    msg = `"${resourceName}" is fewer than the currently defined ${pairedResourceCount} resources on ${uppercaseDay}.`;
                } else if (
                    !isPlanning &&
                    Number(pairedResourceCount) < Number(val)
                ) {
                    msg = `"${resourceName}" must be less than or equal to ${pairedResourceCount} on ${uppercaseDay} because of the configured planning count.`;
                }
            }
        }

        return msg;
    }

    getResourceStatus(day, resourceName) {
        let resourceStatus = null;

        const { edit } = this.state;

        if (
            edit.dayStatuses &&
            edit.dayStatuses[day] &&
            edit.dayStatuses[day].resourceStatuses &&
            edit.dayStatuses[day].resourceStatuses[resourceName]
        ) {
            resourceStatus =
                edit.dayStatuses[day].resourceStatuses[resourceName];
        }

        return resourceStatus;
    }

    getWeekValuesArrayOrdered = (jobWeek) => {
        // Safari sometimes reads this in the wrong format - it should always be stored as YYYY-MM-DD
        const formats = ['YYYY-MM-DD', 'L-d-YYYY'];
        let startDate;

        formats.forEach((format) => {
            const date = moment(jobWeek, format);

            if (date.isValid()) {
                startDate = date.toDate();
            }
        });

        const dates = [];
        dates.push(startDate);
        for (let i = 1; i < 7; i++) {
            dates.push(
                moment(dates[i - 1])
                    .add(1, 'day')
                    .toDate()
            );
        }
        return dates;
    };

    clearErrors = () => this.setState({ errors: {} });

    createJob = async () => {
        const { job } = this.state;

        const response = await util.fetch.post(
            ApiRoutes.job.create(),
            job,
            util.fetch.format.none
        );
        this.processSaveResponse(response);
    };

    doesAfadAssignmentExistForDay = (job, dayName) => {
        if (!job.resources) {
            return false;
        }

        return job.resources.some(
            (r) => this.resourceIsAfad(r) && r[dayName] && r[dayName] > 0
        );
    };

    handleClickResourceDay = (day) => {
        const override =
            this.getExistingOverrideDay(day) || new JobOverride(day);

        this.setState({
            showJobOverrideModal: true,
            currentJobOverride: {
                ...override,
                job: this.state.job,
            },
        });
    };

    handleCloseJobOverride = (data) => {
        if (data) {
            const { job } = { ...this.state };
            const overrides = job.overrides ?? [];

            // Remove circular references
            data.job = {
                weekOfDate: data.job.weekOfDate,
            };

            const existingOverride = overrides.findIndex(
                (override) => override.overrideDay === data.overrideDay
            );

            if (existingOverride === -1) {
                overrides.push(data);
            } else {
                overrides[existingOverride] = data;
            }

            this.setState({
                showJobOverrideModal: false,
                currentJobOverride: null,
                job: {
                    ...job,
                    overrides,
                },
            });
        } else {
            this.setState({
                showJobOverrideModal: false,
                currentJobOverride: null,
            });
        }
    };

    handleSaveError = handleFormSaveError;

    hydrateSetupCharges = () => {
        const { job } = this.state;

        job.resources = job.resources.map((r) => {
            const flaggersRow = job.resources.filter(
                (r) => r.isPlanningOnly == false && r.resourceName == 'Flaggers'
            )[0];

            if (
                r.setupChargeTypeId > 0 &&
                (r.isNew == true || this.resourceHasAnyAssignments(r))
            ) {
                r.monday = flaggersRow.monday > 0 ? 1 : 0;
                r.tuesday = flaggersRow.tuesday > 0 ? 1 : 0;
                r.wednesday = flaggersRow.wednesday > 0 ? 1 : 0;
                r.thursday = flaggersRow.thursday > 0 ? 1 : 0;
                r.friday = flaggersRow.friday > 0 ? 1 : 0;
                r.saturday = flaggersRow.saturday > 0 ? 1 : 0;
                r.sunday = flaggersRow.sunday > 0 ? 1 : 0;
            }

            return { ...r };
        });

        this.setState({ job });
    };

    isRequestedPersonnelSectionAvailable = () => {
        const { job } = this.state;

        if (!job || _.isEmpty(job)) {
            return false;
        }

        return (
            job.resources &&
            job.resources.some((r) => r.isPlanningOnly) &&
            job.resources.some(
                (r) =>
                    this.resourceIsAfad(r) && this.resourceHasAnyAssignments(r)
            )
        );
    };

    notifyError = (message) =>
        toasty.error(
            'Save Unsuccessful',
            <FlexColumnStart>
                <span>There was a server error when saving:</span>
                {!!message && (
                    <span className="pt-2 pb-2 font-weight-bold">{`${message}`}</span>
                )}
                <span>
                    Please try your request again or contact support for
                    assistance.
                </span>
            </FlexColumnStart>
        );

    notifySuccess = () =>
        toasty.success('Job Saved', 'Job saved successfully.');

    overrideDayIsDisabled = (day) => {
        const now = moment();

        const selectedDay =
            typeof day === 'string'
                ? moment(day, moment.ISO_8601)
                : moment(day);

        // Restrict overrides to 7PM the previous day
        selectedDay.subtract(5, 'hours');

        return now.isAfter(selectedDay);
    };

    userCreatingJobForLongTermSchedule = () => {
        const { match } = this.props;

        return Boolean(
            match && match.params && match.params.longTermScheduleId
        );
    };

    populateState = async () => {
        let { showTimesheetOverview, edit } = { ...this.state };
        const { match } = this.props;

        const isForLongTermSchedule = this.userCreatingJobForLongTermSchedule();

        let longTermSchedule = null,
            crew = null,
            employees = [],
            equipments = [],
            equipmentTypes = [],
            dateOverviews = [],
            equipmentGroups = [],
            applicationGroups = [],
            longTermSchedulers = [],
            fieldUsers = [],
            equipmentTypeCounts = [],
            equipmentTypeIdsRequiringMoves = [],
            arcGisLocations = [],
            projectManager = null,
            applicationUserGroups = [];

        // Route params
        // Can route in from a contract page, or from job search, which can pull job by its ID
        // possibly add a way to select contract on here that job will assign to?
        let jobId = this.props.match.params.id; // {job/1}
        let { contractId } = this.props.match.params; // {newJob/1}

        const longTermScheduleId = match.params.longTermScheduleId;

        if (isForLongTermSchedule) {
            longTermSchedule = await util.fetch.js(
                ApiRoutes.longTermSchedule.getSingle(longTermScheduleId)
            );

            const apiStartDate = moment(longTermSchedule.startDate).format(
                MomentDateFormat.ApiUrlRequest
            );
            const apiEndDate = moment(longTermSchedule.endDate).format(
                MomentDateFormat.ApiUrlRequest
            );

            [
                employees,
                equipments,
                equipmentTypes,
                dateOverviews,
                equipmentGroups,
                applicationGroups,
                longTermSchedulers,
                fieldUsers,
                crew,
                equipmentTypeCounts,
                equipmentTypeIdsRequiringMoves,
                arcGisLocations,
                applicationUserGroups,
            ] = await Promise.all([
                util.fetch.js(ApiRoutes.employees.all()),
                util.fetch.js(ApiRoutes.equipment.all()),
                util.fetch.js(ApiRoutes.equipmentType.all()),
                util.fetch.js(
                    ApiRoutes.longTermSchedule.getDateOverview(
                        longTermScheduleId
                    )
                ),
                util.fetch.js(ApiRoutes.equipmentGroup.all()),
                util.fetch.js(ApiRoutes.userGroup.all()),
                util.fetch.js(ApiRoutes.employees.schedulers()),
                util.fetch.js(ApiRoutes.employees.fieldUsers()),
                util.fetch.js(ApiRoutes.crew.get(longTermSchedule.crewId)),
                util.fetch.js(
                    ApiRoutes.equipmentTypeCount.forDateRange(
                        apiStartDate,
                        apiEndDate
                    )
                ),
                util.fetch.js(ApiRoutes.equipmentType.requiringMoves()),
                util.fetch.js(
                    ApiRoutes.arcGisLocations.forContract(
                        longTermSchedule.contractId
                    )
                ),
                util.fetch.js(ApiRoutes.applicationUserGroup.fieldUsers()),
            ]);

            jobId = null;
            contractId = longTermSchedule.contractId;

            projectManager = longTermSchedulers.find(
                (ltsch) => ltsch.id == longTermSchedule.projectManagerId
            );
        }

        // Promises
        const pDispatchLocs = util.fetch.js(
            ApiRoutes.typeAheads.dispatchCompanies()
        );

        const pJobManage = jobId
            ? util.fetch.js(ApiRoutes.job.byId(jobId))
            : { job: new Job(), edit: {}, constrainContactTypes: true };

        const pContract = jobId
            ? null
            : util.fetch.js(ApiRoutes.contract.byId(contractId)); // if new job, get the contract

        const pResources = jobId
            ? null
            : util.fetch.js(ApiRoutes.job.getResources(contractId));

        const pWeeks = util.fetch.js(ApiRoutes.job.weeks());

        let [
            dispatchLocations,
            jobManage,
            contract,
            resources,
            weeks,
            usCounties,
            tenantSettings,
            contractPhases,
        ] = await Promise.all([
            pDispatchLocs,
            pJobManage,
            pContract,
            pResources,
            pWeeks,
            util.fetch.js(ApiRoutes.USCounties.all()),
            util.fetch.js(ApiRoutes.tenant.settings()),
            util.fetch.js(
                ApiRoutes.contractPhases.forContract(
                    contractId,
                    longTermScheduleId
                )
            ),
        ]);

        const { job } = jobManage;

        if (!jobId) {
            job.contract = contract;

            // If it's a new job and there's only 1 dispatch location, set it.
            if (dispatchLocations.length === 1) {
                job.companyId = dispatchLocations[0].value;
            }

            if (job.contract) {
                dispatchLocations = dispatchLocations.filter((x) =>
                    (contract.dispatchLocations ?? []).includes(x.value)
                );
                job.contractId = job.contract.id; // may need to gut this later
                job.description = job.contract.description;
            }
        } else {
            showTimesheetOverview =
                job.resources.filter((x) => x.typeName === 'None').length > 0;
        }

        if (crew) {
            job.foremenId = crew.crewLeadEmployeeId;
            job.crewName = crew.name;
            job.crewLeadEmployeeId = crew.crewLeadEmployeeId ?? null;

            job.crewEmployeeMemberships = _.clone(crew.crewEmployeeMemberships);

            job.crewEquipmentMemberships = _.clone(
                crew.crewEquipmentMemberships
            );
        }

        if (longTermSchedule) {
            job.foremenId = longTermSchedule.leadEmployeeId;

            if (projectManager) {
                job.requestedById = projectManager.id;
            }
        }

        if (dispatchLocations && dispatchLocations.length == 1) {
            job.companyId = dispatchLocations[0].value;
        }

        if (resources) {
            job.resources = resources.map((r) => {
                if (r.id === 0) {
                    r.id = uuid();
                }
                if (r.id === 0 && r.setupChargeTypeId > 0 && !r.isPermit) {
                    r.isNew = true;
                }

                if (isForLongTermSchedule) {
                    if (r.applicationGroupId) {
                        const applicationResource =
                            longTermSchedule.scheduleApplicationGroupCount;

                        if (
                            applicationResource.applicationGroupId ==
                            r.applicationGroupId
                        ) {
                            this.setResourceDayValues(
                                r,
                                applicationResource.count
                            );
                        }
                    } else if (r.equipmentGroupId) {
                        const equipmentGroupResource =
                            longTermSchedule.scheduleEquipmentGroupCounts.find(
                                (segc) =>
                                    segc.equipmentGroupId == r.equipmentGroupId
                            );

                        this.setResourceDayValues(
                            r,
                            equipmentGroupResource.count
                        );
                    }
                }

                return r;
            });

            showTimesheetOverview =
                resources.filter((x) => x.typeName === 'None').length > 0;
        }

        if (longTermSchedule && dateOverviews) {
            const weekJobResources = dateOverviews.map((d) => {
                const weekOfDate = d.weekOfDate;
                const jobResources = [...job.resources];
                const jobOverrides = [];

                let jobContractPhases = [];

                if (
                    longTermSchedule.longTermScheduleContractPhases &&
                    longTermSchedule.longTermScheduleContractPhases.length
                ) {
                    jobContractPhases = _.flatMap(
                        d.activeDates.map((ad) =>
                            longTermSchedule.longTermScheduleContractPhases.map(
                                (ltscp) => {
                                    return {
                                        dayOfWeek: moment(ad).day(),
                                        contractPhaseId: ltscp.contractPhaseId,
                                        targetQuantity: Number(
                                            (
                                                ltscp.targetQuantity /
                                                longTermSchedule.activeDayCount
                                            ).toFixed(2)
                                        ),
                                    };
                                }
                            )
                        )
                    );
                }

                job.jobContractPhases = jobContractPhases;

                return {
                    weekOfDate,
                    jobResources,
                    jobOverrides,
                    jobContractPhases,
                };
            });

            job.weekJobResources = weekJobResources;
        }

        // Week selector setup
        if (!!(job.id ?? 0) > 0) {
            /** The job exists and we don't really support week start changes, so clear it out, set the existing job's week
                as the only week in the array, and lock it down. */
            weeks = [];
            weeks.push({ label: job.weekOfDate, value: job.weekOfDate });
        } else {
            // Get the calculated weeks from the tenant settings, and select the first by default
            weeks = weeks.map((x) => ({
                label: x.startDisplay,
                value: x.startDisplay,
            }));
            // if its monday, we allow one week in past, so select currect index 1, else index 0(for not monday)
            if (new Date().getDay() === 1) {
                job.weekOfDate = weeks[1].value;
            } else {
                job.weekOfDate = weeks[0].value;
            }
        }

        // Copy updated edit permissions.
        edit = Object.assign(edit, jobManage.edit);
        if (job.resources) edit.initialResources = { ...job.resources };

        const customerId = job.contract.companyId;
        const customerSubcontractors = await util.fetch.js(
            ApiRoutes.typeAheads.subcontractors(customerId)
        );

        const originalJob = util.object.clone(job);

        this.setState({
            weeks: [...weeks],
            loading: false,
            dispatchLocations: [...dispatchLocations],
            customerSubcontractors: [...customerSubcontractors],
            job: { ...job },
            edit: { ...edit },
            showTimesheetOverview,
            usCounties,
            tenantSettings,
            originalJob,
            isForLongTermSchedule,
            longTermSchedule,
            crew,
            employees,
            equipments,
            equipmentTypes,
            dateOverviews,
            equipmentGroups,
            applicationGroups,
            fieldUsers,
            longTermSchedulers,
            contractPhases,
            equipmentTypeCounts,
            equipmentTypeIdsRequiringMoves,
            arcGisLocations,
            projectManager,
            applicationUserGroups,
        });
    };

    processSaveResponse = async (response) => {
        if (response.ok) {
            this.resetForm();
            this.notifySuccess();
            this.props.history.push(`${AppNavPaths.Dispatch}`);
        } else {
            let message = '';
            try {
                const responseData = await response.json();
                message = responseData.message;
            } catch (ex) {
                console.warn(ex);
            } finally {
                this.notifyError(message);
                this.resetForm();
            }
        }
    };

    removeSetupCharge = (r) => {
        r.isNew = false;

        r.monday = 0;
        r.tuesday = 0;
        r.wednesday = 0;
        r.thursday = 0;
        r.friday = 0;
        r.saturday = 0;
        r.sunday = 0;

        this.hydrateSetupCharges();
    };

    setResourceDayValues = (resource, count) => {
        resource.monday = count;
        resource.tuesday = count;
        resource.wednesday = count;
        resource.thursday = count;
        resource.friday = count;
        resource.saturday = count;
        resource.sunday = count;
    };

    resetForm = () =>
        this.setState({
            formValidated: false,
            saving: false,
            originalJob: util.object.clone(this.state.job),
        });

    resourceHasAnyAssignments = (resource) =>
        Boolean(
            resource &&
            (resource.monday > 0 ||
                resource.tuesday > 0 ||
                resource.wednesday > 0 ||
                resource.thursday > 0 ||
                resource.friday > 0 ||
                resource.saturday > 0 ||
                resource.sunday > 0)
        );

    resourceIsAfad = (resource) => Boolean(resource && resource.isAFAD);

    saveJob = async () => {
        const { job } = { ...this.state };

        const response = await util.fetch.put(
            ApiRoutes.job.update(job.id),
            job,
            util.fetch.format.none
        );

        this.setPageModified(false);
        this.processSaveResponse(response);
    };

    saveLongTermScheduleJobs = async () => {
        const { job, longTermSchedule, jobBeforeSave, lowboyResources } =
            this.state;

        if (!job.foremenId) {
            toasty.error('Missing foreman', 'Please select a foreman.');
            return;
        }

        job.longTermScheduleId = longTermSchedule.id;
        job.lowboyResources = lowboyResources;

        this.setPageModified(false);

        const url = ApiRoutes.longTermSchedule.createJobs();

        const response = await util.fetch
            .andGetResponse(util.fetch.types.post, url, job)
            .catch(this.handleSaveError);

        if (!response || response.error || response.message) {
            this.setState({
                saving: false,
                job: jobBeforeSave,
                jobBeforeSave: null,
            });
        } else {
            this.setState({ originalJob: job }, () => {
                toasty.success(
                    'Jobs Published',
                    'Jobs published. Returning to the calendar overview.'
                );

                const { history } = this.props;

                history.push(AppNavPaths.LongTermScheduleCalendar);
            });
        }
    };

    validateSetupCharges = () => {
        const { job } = this.state;

        if (job.contract.setupChargesRequired) {
            const setupCharges = job.resources.filter(
                (r) => r.setupChargeTypeId > 0
            );
            let hasSetupCharge = false;

            for (let i = 0; i < setupCharges.length; i++) {
                if (this.resourceHasAnyAssignments(setupCharges[i])) {
                    hasSetupCharge = true;
                    break;
                }
            }

            if (!hasSetupCharge) {
                toasty.error('At least one setup charge is required.');
                return false;
            }
        }

        return true;
    };

    hasMissingArcGisLocations = () => {
        const { job, dateOverviews, longTermSchedule, isForLongTermSchedule } =
            this.state;

        if (
            !isForLongTermSchedule ||
            longTermSchedule.arcGisLocationId ||
            !this.areAnyLocationsDefined()
        ) {
            return false;
        }

        return !(dateOverviews || []).every((d) => {
            const weekJobResource = (job.weekJobResources || []).find(
                (wjr) => wjr.weekOfDate == d.weekOfDate
            );
            const jobOverrides = weekJobResource?.jobOverrides || [];

            return (d.activeDates || []).every((ad) =>
                jobOverrides.some(
                    (jo) =>
                        jo.arcGisLocationId &&
                        moment(jo.overrideDate).isSame(ad, 'day')
                )
            );
        });
    };

    validateArcGisLocationsForDays = () => {
        if (this.hasMissingArcGisLocations()) {
            toasty.error(
                'Missing location',
                'Please select an ArcGIS location for every day being published.'
            );
            return false;
        }

        return true;
    };

    renderResourceHeader = (weekdays, isPlanningOnly) => {
        const { isForLongTermSchedule } = this.state;

        if (isForLongTermSchedule) {
            return null;
        }

        return (
            <thead>
                <tr>
                    <th>Resource</th>
                    <th>Type</th>

                    {weekdays.map((day) => {
                        const existing = this.getExistingOverrideDay(day);
                        const overrideDisabled =
                            this.overrideDayIsDisabled(day);

                        if (
                            isPlanningOnly ||
                            (overrideDisabled && !existing) ||
                            !this.state.tenantSettings?.tenantSettings
                                .enableJobOverrides
                        ) {
                            return (
                                <th
                                    key={day}
                                    className="resource-weekday-col text-center"
                                >
                                    <div className="d-flex flex-column">
                                        <span>
                                            {
                                                Weekdays[day.getDay()]
                                                    .abbreviation
                                            }
                                        </span>
                                        {!isForLongTermSchedule && (
                                            <span>
                                                {moment(day).format('M/D')}
                                            </span>
                                        )}
                                    </div>
                                </th>
                            );
                        }

                        return (
                            <th
                                key={day}
                                className="resource-weekday-col text-center"
                            >
                                <div
                                    className={`d-flex flex-column site-link ${
                                        existing && 'text-info'
                                    }`}
                                    role="button"
                                    onClick={() =>
                                        this.handleClickResourceDay(day)
                                    }
                                >
                                    <span>
                                        {Weekdays[day.getDay()].abbreviation}
                                    </span>

                                    {!isForLongTermSchedule && (
                                        <span>{moment(day).format('M/D')}</span>
                                    )}

                                    <FontAwesomeIcon
                                        icon={overrideDisabled ? faEye : faEdit}
                                        size="sm"
                                        className="ml-1"
                                    />
                                </div>
                            </th>
                        );
                    })}
                    <th />
                </tr>
            </thead>
        );
    };

    getFilteredResources = (jobResources, isPlanningOnly) =>
        jobResources.filter(
            (r) =>
                r.isPlanningOnly == Boolean(isPlanningOnly) &&
                (r.setupChargeTypeId == null ||
                    (r.setupChargeTypeId > 0 &&
                        (r.monday > 0 ||
                            r.tuesday > 0 ||
                            r.wednesday > 0 ||
                            r.thursday > 0 ||
                            r.friday > 0 ||
                            r.saturday > 0 ||
                            r.sunday > 0)) ||
                    (r.setupChargeTypeId > 0 && r.isNew == true))
        );

    getFilteredJobResources = (isPlanningOnly) => {
        const { job } = this.state;

        return this.getFilteredResources(job.resources, isPlanningOnly);
    };

    getFlaggerGroup = () => {
        const { applicationGroups } = this.state;

        return applicationGroups.find((ag) =>
            ag.groupName.startsWith('Flagger')
        );
    };

    areAnyLocationsDefined = () => {
        const { arcGisLocations } = this.state;

        return Boolean(arcGisLocations && arcGisLocations.length > 0);
    };

    getHasSelectedCrewWithoutLead = () => {
        const { job, crew, isForLongTermSchedule } = this.state;
        const crewEmployeeMemberships = job.crewEmployeeMemberships || [];
        const crewLeadEmployeeId =
            job.crewLeadEmployeeId !== undefined
                ? job.crewLeadEmployeeId
                : crew?.crewLeadEmployeeId;

        return (
            isForLongTermSchedule &&
            crewEmployeeMemberships.length > 0 &&
            !crewEmployeeMemberships.some(
                (employeeId) => employeeId == crewLeadEmployeeId
            )
        );
    };

    onJobUpdated = (job, jobResourcesValid, phasesValid) => {
        this.setState({ job, pageModified: true });

        if (jobResourcesValid !== undefined) {
            this.setState({ jobResourcesValid });
        }

        if (phasesValid !== undefined) {
            this.setState({ phasesValid });
        }

        this.hydrateSetupCharges();
    };

    renderResources = (weekdays, isPlanningOnly) => {
        const { job, edit, longTermSchedule, isForLongTermSchedule } =
            this.state;

        if (
            isForLongTermSchedule ||
            !job.resources ||
            !(weekdays ?? []).length
        ) {
            return '';
        }

        const filteredJobResources =
            this.getFilteredJobResources(isPlanningOnly);

        return filteredJobResources.map((resource, i) => (
            <tr key={resource.resourceName}>
                <td>{resource.resourceName}</td>
                <td>{resource.typeName}</td>
                {weekdays.map((day) => {
                    const dayObj = Weekdays[day.getDay()];
                    const dayName = dayObj.name.toLowerCase();
                    const dayNameHasTimesheet = `${dayName}HasTimesheet`;

                    const resourceIsDisabled =
                        resource[dayNameHasTimesheet] === true ||
                        (isPlanningOnly &&
                            !this.doesAfadAssignmentExistForDay(
                                job,
                                dayName
                            )) ||
                        (longTermSchedule &&
                            !longTermSchedule.activeDays.includes(dayObj.id));

                    return (
                        <td key={day} className="resource-weekday-column">
                            <input
                                id={`r${dayName}`}
                                name={`${dayName}`}
                                className="w-100"
                                required
                                value={resource[dayName]}
                                onChange={this.onChangeResourceDay.bind(
                                    this,
                                    resource
                                )}
                                readOnly={
                                    !edit.allowResources ||
                                    resource.setupChargeTypeId > 0
                                }
                                disabled={resourceIsDisabled}
                                title={
                                    resource[dayNameHasTimesheet] === true
                                        ? 'Approved Timesheet Exists'
                                        : ''
                                }
                            />
                        </td>
                    );
                })}
                <td
                    style={{
                        textAlign: 'center',
                        paddingLeft: '0px',
                        paddingRight: '0px',
                        paddingTop: '7px',
                    }}
                >
                    {resource.setupChargeTypeId > 0 && (
                        <FontAwesomeIcon
                            icon={faTimes}
                            title="Remove setup charge"
                            className="text-danger cursor-pointer"
                            onClick={() => this.removeSetupCharge(resource)}
                        />
                    )}
                </td>
            </tr>
        ));
    };

    getFormHeading = () => {
        const { job, isForLongTermSchedule } = this.state;

        if (isForLongTermSchedule) {
            return 'New Jobs';
        }

        const existing = Boolean(job.id);

        return !existing
            ? 'New Order'
            : `Edit Order: ${(job.contract ?? {}).number}${
                  job.contractSequence ? `-${job.contractSequence}` : ''
              }`;
    };

    getSaveButtonText = () => {
        const { job, isForLongTermSchedule } = this.state;

        if (isForLongTermSchedule) {
            return 'Publish Orders';
        }

        const existing = Boolean(job.id);

        return !existing ? 'Save New Order' : 'Save Order Details';
    };

    toDayAndDateFormat = (date) =>
        moment(date).format(MomentDateFormat.WeekDayNameAndDate);

    getActiveDaysDisplay = () => {
        const { longTermSchedule } = this.state;

        const activeWeekdays = Weekdays.filter((wd) =>
            longTermSchedule.activeDays.includes(wd.id)
        );

        return activeWeekdays.map((wd) => wd.name).join(', ');
    };

    onCrewComponentsChanged = (
        crewEmployeeMemberships,
        crewEquipmentMemberships,
        employeeOverrideStartTimes,
        equipmentOverrideStartTimes
    ) => {
        const { job } = this.state;

        if (crewEmployeeMemberships != null) {
            const foremanWasCrewMember = (job.crewEmployeeMemberships || []).some(
                (employeeId) => employeeId == job.foremenId
            );

            job.crewEmployeeMemberships = crewEmployeeMemberships;

            if (
                foremanWasCrewMember &&
                !crewEmployeeMemberships.some(
                    (employeeId) => employeeId == job.foremenId
                )
            ) {
                job.foremenId = null;
            }
        }

        if (crewEquipmentMemberships != null) {
            job.crewEquipmentMemberships = crewEquipmentMemberships;
        }

        if (employeeOverrideStartTimes != null) {
            job.employeeOverrideStartTimes = employeeOverrideStartTimes;
        }

        if (equipmentOverrideStartTimes != null) {
            job.equipmentOverrideStartTimes = equipmentOverrideStartTimes;
        }

        this.setState({ job });
    };

    render() {
        const {
            loading,
            job,
            errors,
            formValidated,
            dispatchLocations,
            saving,
            weeks,
            tableRequired,
            meetingLocationRequired,
            jobLocationRequired,
            edit,
            resourceTableError,
            showDeleteModal,
            customerSubcontractors,
            tenantSettings,
            showAddSetupCharge,
            showJobOverrideModal,
            currentJobOverride,
            showAddPermitFees,
            pageModified,
            originalJob,
            isForLongTermSchedule,
            crew,
            equipments,
            employees,
            equipmentTypes,
            projectManager,
            fieldUsers,
            phasesValid,
            longTermSchedule,
            contractPhases,
            jobResourcesValid,
        } = this.state;

        const requestedPersonnelSectionAvailable =
            this.isRequestedPersonnelSectionAvailable();

        const supportedFiles = SupportedFileExtensions.image
            .concat(SupportedFileExtensions.document)
            .join(',');

        const showConfirmationPrompt =
            pageModified || !isEqual(job, originalJob);

        const unusedSetupChargeTypes = job.resources.filter(
            (r) => r.setupChargeTypeId > 0 && !r.isPermit
        );

        const unusedPermitFees = job.resources.filter(
            (r) => r.setupChargeTypeId > 0 && r.isPermit
        );

        const crewDetailsDisabled = !job.startTime;
        const hasSelectedCrewWithoutLead =
            this.getHasSelectedCrewWithoutLead();

        if (!!loading || !tenantSettings) {
            return <FormCircularProgress />;
        }

        const { jobUploadsEnabled } = {
            ...this.context.tenant.tenantSettings,
        };

        const anyLocationsDefined = this.areAnyLocationsDefined();

        const weekdays = this.getWeekValuesArrayOrdered(job.weekOfDate);

        return (
            <>
                <Prompt
                    when={!!showConfirmationPrompt}
                    message="You have unsaved changes, are you sure you want to leave?"
                />

                <AppPageForm
                    formId="jobForm"
                    formHeadingIcon={faTruck}
                    formHeading={this.getFormHeading()}
                    formName="jobForm"
                    formRef={this.formRef}
                    onSubmit={this.onSubmit}
                    setIsValidated={(value) => {
                        this.setState({ formValidated: value });
                    }}
                    isValidated={formValidated}
                    saving={saving}
                    errors={errors}
                    loading={loading}
                    noContainer
                >
                    <SubHeading>Job Details</SubHeading>
                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="contractNumber"
                                    text="Job Number"
                                />
                                <input
                                    id="contractNumber"
                                    name="contractNumber"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={(job.contract ?? {}).number}
                                />
                            </FormGroup>
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="contractDescription"
                                    text="Description"
                                />
                                <input
                                    id="contractDescription"
                                    name="contractDescription"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {}).description
                                    }
                                />
                            </FormGroup>
                        </FormGroupColumn>
                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="customerName"
                                    text="Customer Name"
                                />
                                <input
                                    id="customerName"
                                    name="customerName"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {}).customerName
                                    }
                                />
                            </FormGroup>
                            {(job.contract ?? {}).operationsCenterName && (
                                <FormGroup>
                                    <FormLabel
                                        className="mb-1"
                                        htmlFor="operationsCenterName"
                                        text="Operations Center"
                                    />
                                    <input
                                        id="operationsCenterName"
                                        name="operationsCenterName"
                                        readOnly
                                        className="form-control-plaintext"
                                        defaultValue={
                                            (job.contract ?? {})
                                                .operationsCenterName
                                        }
                                    />
                                </FormGroup>
                            )}
                            <FormGroup>
                                <FormLabel
                                    className="mb-1"
                                    htmlFor="schedule"
                                    text="Schedule"
                                />
                                <input
                                    id="schedule"
                                    name="schedule"
                                    readOnly
                                    className="form-control-plaintext"
                                    defaultValue={
                                        (job.contract ?? {})
                                            .contractScheduleTypeName
                                    }
                                />
                            </FormGroup>
                        </FormGroupColumn>
                    </GroupedRow>
                    <SubHeading>Setup</SubHeading>
                    <GroupedRow>
                        {!isForLongTermSchedule && (
                            <FormGroupColumn>
                                <FormGroup>
                                    <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                        <label
                                            htmlFor="weekOfDate"
                                            className="control-label required"
                                        >
                                            Week Of
                                        </label>
                                    </div>

                                    <ValidatedSelect
                                        id="weekOfDate"
                                        className="job-form-select-min"
                                        name="job.weekOfDate"
                                        options={weeks}
                                        value={
                                            weeks.find(
                                                (x) =>
                                                    x.value === job.weekOfDate
                                            ) ?? ''
                                        }
                                        onChange={this.onSelectChanged}
                                        validationMessage="A week start selection is required."
                                        isDisabled={!edit.allowWeekOfDate}
                                    />
                                </FormGroup>
                            </FormGroupColumn>
                        )}

                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="requestedBy"
                                        className="control-label"
                                    >
                                        Project Manager
                                    </label>
                                </div>
                                {projectManager && (
                                    <Input
                                        type="text"
                                        disabled={true}
                                        value={projectManager.fullName}
                                    />
                                )}
                                {!projectManager && (
                                    <Alert color="danger" fade={false}>
                                        <FontAwesomeIcon
                                            icon={faTriangleExclamation}
                                            className="mr-2"
                                        />
                                        No project manager defined
                                    </Alert>
                                )}
                            </FormGroup>
                        </FormGroupColumn>

                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="foremenId"
                                        className="control-label required"
                                    >
                                        Foreman
                                    </label>
                                </div>
                                <ValidatedSelect
                                    id="foremen"
                                    className="job-form-select-min"
                                    name="job.foremenId"
                                    options={fieldUsers}
                                    value={
                                        (fieldUsers ?? []).find(
                                            (x) => x.id == job.foremenId
                                        ) ?? ''
                                    }
                                    onChange={this.onForemenChanged}
                                    validationMessage="A foremen selection is required."
                                    isDisabled={!edit.allowForemen}
                                    getOptionLabel={(e) => e.fullName}
                                />
                            </FormGroup>
                            {(job.contract ?? {}).subcontractorsApply && (
                                <FormGroup>
                                    <FormLabel
                                        htmlFor="subcontractor"
                                        text="Subcontractor"
                                        required={
                                            !!job.contract.subcontractorsApply
                                        }
                                    />
                                    <ValidatedSelect
                                        id="subcontractor"
                                        className="job-form-select-min"
                                        name="job.subcontractorCompanyId"
                                        options={customerSubcontractors}
                                        value={
                                            (customerSubcontractors ?? []).find(
                                                (x) =>
                                                    x.value ===
                                                    job.subcontractorCompanyId
                                            ) ?? ''
                                        }
                                        onChange={(selection) => {
                                            const { value } = selection;
                                            this.setState(
                                                (state) => (
                                                    (state.job.subcontractorCompanyId =
                                                        value),
                                                    state
                                                )
                                            );
                                        }}
                                        required
                                        validationMessage="A subcontractor selection is required."
                                    />
                                </FormGroup>
                            )}
                        </FormGroupColumn>
                    </GroupedRow>

                    <GroupedRow>
                        <FormGroupColumn>
                            <FormGroup>
                                <div className="d-flex flex-row flex-nowrap align-items-baseline justify-content-start">
                                    <label
                                        htmlFor="companyId"
                                        className="control-label required"
                                    >
                                        Dispatching
                                    </label>
                                </div>
                                <ValidatedSelect
                                    id="companyId"
                                    className="job-form-select-min"
                                    name="job.companyId"
                                    options={dispatchLocations}
                                    value={
                                        (dispatchLocations ?? []).find(
                                            (x) => x.value === job.companyId
                                        ) ?? ''
                                    }
                                    onChange={this.onSelectChanged}
                                    required
                                    validationMessage="A dispatch selection is required."
                                    isDisabled={!edit.allowJobLocation}
                                />
                            </FormGroup>
                        </FormGroupColumn>

                        <FormGroupColumn>
                            <FormGroup>
                                <FormLabel
                                    htmlFor="startTime"
                                    text="Start Time"
                                    required
                                />
                                <ConstrainedTimeInput
                                    id="startTime"
                                    required
                                    name="job.startTime"
                                    value={job.startTime ?? ''}
                                    onChange={this.onChange}
                                    readOnly={!edit.allowStartTime}
                                    invalid={!job.startTime}
                                />
                                <small className="invalid-feedback text-danger">
                                    Start Time is required.
                                </small>
                            </FormGroup>
                        </FormGroupColumn>
                    </GroupedRow>
                    <FormDivider />
                    <GroupedRow>
                        {job.contract.workOrderTypeId !== 3 && false && (
                            <FormGroupColumn>
                                <FormGroup>
                                    <FormLabel
                                        htmlFor="workOrderNumber"
                                        text="Work Order"
                                    />
                                    <input
                                        id="workOrderNumber"
                                        name="job.workOrderNumber"
                                        className="form-control"
                                        defaultValue={job.workOrderNumber ?? ''}
                                        onChange={this.onChange}
                                        readOnly={!edit.allowWorkOrderNumber}
                                    />
                                </FormGroup>
                            </FormGroupColumn>
                        )}
                    </GroupedRow>

                    {isForLongTermSchedule && (
                        <CrewDisplay
                            crew={crew}
                            employees={employees}
                            equipments={equipments}
                            equipmentTypes={equipmentTypes}
                            onCrewComponentsChanged={
                                this.onCrewComponentsChanged
                            }
                            onJobUpdated={this.onJobUpdated}
                            job={job}
                            disabled={crewDetailsDisabled}
                            hasSelectedCrewWithoutLead={
                                hasSelectedCrewWithoutLead
                            }
                        />
                    )}

                    <GroupedRow>
                        <Col>
                            <FormGroup className="mb-0">
                                {!isForLongTermSchedule && (
                                    <FormLabel text="Resources" required />
                                )}

                                {isForLongTermSchedule && (
                                    <FormLabel text="Additional Details" />
                                )}

                                <div
                                    className="job-form-table-scroll"
                                    style={tableRequired}
                                >
                                    <table
                                        className={cls(
                                            'table table-sm table-bordered',
                                            {
                                                'border-top-0':
                                                    this.props.noTopBorder,
                                            }
                                        )}
                                    >
                                        {this.renderResourceHeader(weekdays)}
                                        <tbody>
                                            {!(job.resources ?? []).length ? (
                                                <tr key="emptyRow">
                                                    <td
                                                        colSpan="9"
                                                        className="text-center"
                                                    >
                                                        <small>
                                                            No resources found
                                                            for this order.
                                                        </small>
                                                    </td>
                                                </tr>
                                            ) : (
                                                this.renderResources(weekdays)
                                            )}
                                        </tbody>
                                    </table>

                                    <LongTermScheduleResourceTable
                                        {...this.state}
                                        {...this.props}
                                        onJobUpdated={this.onJobUpdated}
                                        onManagedLowboyResourceChange={
                                            this.onManagedLowboyResourceChange
                                        }
                                        disabled={crewDetailsDisabled}
                                    />
                                </div>
                                {!_.isEmpty(tableRequired) && (
                                    <small className="text-danger">
                                        {resourceTableError}
                                    </small>
                                )}
                            </FormGroup>
                        </Col>
                    </GroupedRow>

                    {requestedPersonnelSectionAvailable && (
                        <GroupedRow>
                            <Col>
                                <FormGroup className="mb-0">
                                    <FormLabel
                                        text="Requested Personnel"
                                        required
                                    />
                                    <div
                                        className="job-form-table-scroll"
                                        style={tableRequired}
                                    >
                                        <table
                                            className={cls(
                                                'table table-sm table-bordered',
                                                {
                                                    'border-top-0':
                                                        this.props.noTopBorder,
                                                }
                                            )}
                                        >
                                            {this.renderResourceHeader(
                                                weekdays,
                                                true
                                            )}
                                            <tbody>
                                                {this.renderResources(
                                                    weekdays,
                                                    true
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </FormGroup>
                            </Col>
                        </GroupedRow>
                    )}

                    {job.contract.setupChargesRequired && (
                        <GroupedRow>
                            <FormGroup>
                                <div style={{ marginLeft: '30px' }}>
                                    <Button
                                        size="sm"
                                        color="primary"
                                        name="jobForm"
                                        onClick={this.onAddSetupChargeClick}
                                    >
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            icon={faPlus}
                                        />
                                        Add Setup Charge
                                    </Button>
                                </div>
                            </FormGroup>
                        </GroupedRow>
                    )}

                    {job.contract.permitFeesApply && (
                        <FormGroup style={{ marginBottom: '5px' }}>
                            <div style={{ marginLeft: '30px' }}>
                                <FormCheckbox
                                    id="permitFeesApply"
                                    name="permitFeesApply"
                                    checked={job.permitFeesApply ?? ''}
                                    onChange={this.onPermitFeesApplyChange}
                                    labelText="Permit Fees Apply"
                                />
                            </div>
                        </FormGroup>
                    )}

                    {job.contract.permitFeesApply && job.permitFeesApply && (
                        <FormGroup>
                            <div style={{ marginLeft: '60px' }}>
                                <Button
                                    size="sm"
                                    color="secondary"
                                    name="jobForm"
                                    onClick={this.onAddPermitFeesClick}
                                >
                                    <FontAwesomeIcon
                                        className="mr-2"
                                        icon={faPlus}
                                    />
                                    Add Permit Fees...
                                </Button>
                            </div>
                        </FormGroup>
                    )}

                    {!anyLocationsDefined && (
                        <>
                            <GroupedRow>
                                <FormGroupColumn>
                                    <FormGroup>
                                        <FormLabel
                                            htmlFor="meetingLocation"
                                            text="Meeting Location"
                                            required
                                        />
                                        {job.meetingLocation ? (
                                            <FlexStartRow>
                                                <SmallOutlineButton
                                                    onClick={() => {
                                                        this.onEditLocation(
                                                            'meetingLocation'
                                                        );
                                                    }}
                                                    text="Edit"
                                                />

                                                <span className="form-control-plaintext">
                                                    {
                                                        job.meetingLocation
                                                            .address1
                                                    }{' '}
                                                    {job.meetingLocation.city}
                                                    {', '}
                                                    {job.meetingLocation.state}
                                                    {', '}
                                                    {job.meetingLocation.zip}
                                                </span>
                                            </FlexStartRow>
                                        ) : (
                                            <Button
                                                type="button"
                                                color="secondary"
                                                size="sm"
                                                style={meetingLocationRequired}
                                                onClick={() =>
                                                    this.onAddLocation(
                                                        'meetingLocation'
                                                    )
                                                }
                                                disabled={crewDetailsDisabled}
                                            >
                                                Add Meeting Location
                                            </Button>
                                        )}
                                        {!_.isEmpty(
                                            meetingLocationRequired
                                        ) && (
                                            <small className="text-danger">
                                                Meeting location is required.
                                            </small>
                                        )}
                                    </FormGroup>
                                </FormGroupColumn>
                                <FormGroupColumn>
                                    <FormGroup>
                                        <FormLabel
                                            htmlFor="jobLocation"
                                            text="Job Location"
                                            required
                                        />
                                        {job.jobLocation ? (
                                            <FlexStartRow>
                                                <SmallOutlineButton
                                                    onClick={() => {
                                                        this.onEditLocation(
                                                            'jobLocation'
                                                        );
                                                    }}
                                                    text="Edit"
                                                    disabled={
                                                        !edit.allowJobLocation
                                                    }
                                                />

                                                <span className="form-control-plaintext">
                                                    {job.jobLocation.address1}{' '}
                                                    {job.jobLocation.city}
                                                    {', '}
                                                    {job.jobLocation.state}
                                                    {', '}
                                                    {job.jobLocation.zip}
                                                </span>
                                            </FlexStartRow>
                                        ) : (
                                            <Button
                                                type="button"
                                                color="secondary"
                                                size="sm"
                                                style={jobLocationRequired}
                                                onClick={() => {
                                                    this.onAddLocation(
                                                        'jobLocation'
                                                    );
                                                }}
                                                disabled={crewDetailsDisabled}
                                            >
                                                Add Order Location
                                            </Button>
                                        )}
                                        {!_.isEmpty(jobLocationRequired) && (
                                            <small className="text-danger">
                                                Order location is required.
                                            </small>
                                        )}
                                    </FormGroup>
                                </FormGroupColumn>
                            </GroupedRow>
                        </>
                    )}

                    <GroupedRow>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="notes" text="Notes" />
                                <textarea
                                    id="notes"
                                    name="job.notes"
                                    className="form-control"
                                    defaultValue={job.notes ?? ''}
                                    onChange={this.onChange}
                                    placeholder="Enter notes to field staff here."
                                    type="text"
                                    maxLength="500"
                                    rows="5"
                                    readOnly={!edit.allowNotes}
                                    disabled={crewDetailsDisabled}
                                />
                            </FormGroup>
                        </Col>
                    </GroupedRow>
                    {isForLongTermSchedule && (
                        <>
                            <GroupedRow>
                                <Col>
                                    <Alert fade={false} color="warning">
                                        <FontAwesomeIcon
                                            className="mr-2"
                                            size="xl"
                                            icon={faInfoCircle}
                                        />
                                        Publishing a Long-Term Schedule triggers
                                        a number of actions and is not easily
                                        reversed. Please be sure the details are
                                        correct before proceeding.
                                    </Alert>
                                </Col>
                            </GroupedRow>

                            <PhaseTotalWarning
                                job={job}
                                longTermSchedule={longTermSchedule}
                                contractPhases={contractPhases}
                            />
                        </>
                    )}
                    <FlexCenterRow>
                        <Button
                            size="sm"
                            type="submit"
                            color="primary"
                            name="jobForm"
                            disabled={
                                !phasesValid ||
                                !jobResourcesValid ||
                                !job.requestedById ||
                                !job.startTime ||
                                hasSelectedCrewWithoutLead ||
                                this.hasMissingArcGisLocations()
                            }
                        >
                            <FontAwesomeIcon className="mr-2" icon={faSave} />
                            {this.getSaveButtonText()}
                        </Button>
                    </FlexCenterRow>
                    {!!jobUploadsEnabled && (job.id ?? 0) > 0 && (
                        <Row>
                            <Col>
                                <FormGroup>
                                    <FormLabel text="Attach Files" />
                                    <FileUpload
                                        id="jobUploader"
                                        ref={this.uploadsRef}
                                        accept={supportedFiles}
                                        maxNameLength={150}
                                        url={ApiRoutes.job.postAttachments(
                                            job.id
                                        )}
                                        onUploadComplete={() =>
                                            this.getAttachments()
                                        }
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <JobFileAttachments
                                        job={job}
                                        onRemoveAttachment={
                                            this.onRemoveAttachment
                                        }
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    <FlexCenterRow className="mb-3 mt-4">
                        {edit.allowDelete && (
                            <Button
                                size="sm"
                                type="button"
                                color="danger"
                                name="jobForm"
                                onClick={() =>
                                    this.setState({ showDeleteModal: true })
                                }
                            >
                                <FontAwesomeIcon
                                    className="mr-2"
                                    icon={faTrashAlt}
                                />
                                Delete Job
                            </Button>
                        )}
                    </FlexCenterRow>
                </AppPageForm>
                <AddressFormNew
                    id="jobAddressForm"
                    ref={this.addressFormRef}
                    contractUsesPrevailingWage={job.contract.prevailingWage}
                    onSaveCallback={(address) => this.onSaveAddress(address)}
                />
                <Modal isOpen={showDeleteModal}>
                    <ModalHeader>Delete Job</ModalHeader>
                    <ModalBody>
                        Are you sure you want to delete this job?
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="primary"
                            onClick={this.onDeleteConfirmed}
                        >
                            Ok
                        </Button>
                        <Button
                            color="primary"
                            onClick={() =>
                                this.setState({ showDeleteModal: false })
                            }
                        >
                            Cancel
                        </Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={showAddSetupCharge}>
                    <ModalHeader>Add Setup Charge</ModalHeader>
                    <ModalBody>
                        <div className="job-form-table-scroll">
                            <table className="table table-sm table-bordered table-striped payroll-table">
                                <thead className="text-muted">
                                    <tr>
                                        <th style={{ width: '50px' }} />
                                        <th className="invoiceHourlyCharge">
                                            Charge Name
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!unusedSetupChargeTypes?.length ? (
                                        <tr>
                                            <td className="text-center">
                                                No Setup Charges Available
                                            </td>
                                        </tr>
                                    ) : (
                                        unusedSetupChargeTypes?.map(
                                            (charge, charge_index) => {
                                                const id = `${charge.id}|${uuid()}`;

                                                return (
                                                    <tr key={id}>
                                                        <td
                                                            style={{
                                                                textAlign:
                                                                    'center',
                                                            }}
                                                        >
                                                            <input
                                                                id={id}
                                                                name={id}
                                                                type="checkbox"
                                                                checked={
                                                                    charge.isNew ==
                                                                    true
                                                                }
                                                                onChange={(
                                                                    x
                                                                ) => {
                                                                    charge.isNew =
                                                                        x.currentTarget.checked;

                                                                    this.setState(
                                                                        {
                                                                            charge,
                                                                        }
                                                                    );

                                                                    this.hydrateSetupCharges();
                                                                }}
                                                            />
                                                        </td>
                                                        <td className="invoiceHourlyResource">
                                                            <label htmlFor={id}>
                                                                {
                                                                    charge.resourceName
                                                                }
                                                            </label>
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.onAddSetupCharge}>
                            Done
                        </Button>
                    </ModalFooter>
                </Modal>

                {Boolean(currentJobOverride) && (
                    <JobOverrideModal
                        edit={edit}
                        open={showJobOverrideModal}
                        jobOverride={currentJobOverride}
                        setFormOpened={this.context.setFormOpened}
                        onClose={this.handleCloseJobOverride}
                        isReadOnly={this.overrideDayIsDisabled(
                            currentJobOverride.overrideDate
                        )}
                        setOverride={this.setPageModified}
                    />
                )}

                <Modal isOpen={showAddPermitFees}>
                    <ModalHeader>Add Permit Fees</ModalHeader>
                    <ModalBody>
                        <div className="job-form-table-scroll">
                            <table className="table table-sm table-bordered table-striped payroll-table">
                                <thead className="text-muted">
                                    <tr>
                                        <th style={{ width: '50px' }} />
                                        <th className="invoiceHourlyCharge">
                                            Charge Name
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!unusedSetupChargeTypes?.length ? (
                                        <tr>
                                            <td className="text-center">
                                                No Permit Fees Available
                                            </td>
                                        </tr>
                                    ) : (
                                        unusedPermitFees?.map(
                                            (charge, charge_index) => (
                                                <tr
                                                    key={`${charge.id}|${uuid()}`}
                                                >
                                                    <td
                                                        style={{
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                charge.isNew ==
                                                                true
                                                            }
                                                            onChange={(x) => {
                                                                charge.isNew =
                                                                    x.currentTarget.checked;

                                                                this.setState({
                                                                    charge,
                                                                });

                                                                this.hydrateSetupCharges();
                                                            }}
                                                        />
                                                    </td>
                                                    <td className="invoiceHourlyResource">
                                                        {charge.resourceName}
                                                    </td>
                                                </tr>
                                            )
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.onAddPermitFees}>
                            Done
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default withRouter(JobForm);
